module.exports = __webpack_public_path__ + "static/media/My Resume.0a04bc6c.pdf";